module.exports = __webpack_public_path__ + "40c198c940513b5ad59391497f61989c.woff2";